import { Card, Grid, Typography, useTheme } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';

interface KaziTotalVsHiredChartProps {
  chartKey: string;
  title: string;
  dataset: { label: string; totalCount: number; hiredCount: number }[];
  xAxisLabel?: string;
  height?: number;
  onItemClick?: (item: any) => void;
}

export const KaziTotalVsHiredBarChart = ({
  chartKey,
  title,
  dataset,
  xAxisLabel,
  height = 400,
  onItemClick,
}: KaziTotalVsHiredChartProps) => {
  const theme = useTheme();

  // Calculate totals across the dataset for legend display
  const totalAll = dataset.reduce((sum, item) => sum + item.totalCount, 0);
  const totalHired = dataset.reduce((sum, item) => sum + item.hiredCount, 0);

  return (
    <Card
      sx={{
        borderRadius: '12px',
        padding: '24px',
        margin: '24px',
      }}
    >
      <Grid container gap={'20px'} key={chartKey} width={'100%'}>
        <Typography variant="lora-headline-small">{title}</Typography>
        <BarChart
          dataset={dataset}
          xAxis={[{ scaleType: 'band', dataKey: 'label', label: xAxisLabel }]}
          yAxis={[{ label: 'Talents' }]}
          series={[
            {
              dataKey: 'totalCount',
              label: `Total (${totalAll})`,
              color: theme.palette.secondary.dark,
              valueFormatter: v => `${v}`,
            },
            {
              dataKey: 'hiredCount',
              label: `Hired (${totalHired})`,
              color: theme.palette.primary.main,
              valueFormatter: v => `${v}`,
            },
          ]}
          height={height}
          sx={{
            [`.${axisClasses.left} .${axisClasses.label}`]: {
              transform: 'translate(-10px, 0)',
            },
          }}
          onItemClick={(_, params) => {
            const clickedItem = dataset[params.dataIndex];
            onItemClick?.(clickedItem); // Pass clicked data back to parent
          }}
        />
      </Grid>
    </Card>
  );
};
